import { render, staticRenderFns } from "./DescColorChipRenderer.vue?vue&type=template&id=3bac63aa&scoped=true"
import script from "./DescColorChipRenderer.vue?vue&type=script&lang=js"
export * from "./DescColorChipRenderer.vue?vue&type=script&lang=js"
import style0 from "./DescColorChipRenderer.vue?vue&type=style&index=0&id=3bac63aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bac63aa",
  null
  
)

export default component.exports